export const ZOOM_VALUES = {
  START_ZOOM: 1,
  ZOOM_DESKTOP_VALUE: 0.5,
  ZOOM_MOBILE_VALUE: 0.03,
  ZOOM_DURING_SHAPE_INTERSECTION: 0.00003,
};

export const MOVED_IMAGE_VALUE = 100;
